import React, {Component} from 'react'

import Popup from '../Popup/index';

import Registry from '../../../registry/index';

class LoginErrorPopup extends Popup {
    constructor(props) {
        super(props);

        this.userClosable = false;
        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    render() {
        let lang = Registry.get('locale');

        let {chatUrlSecondary, chatroomNameSecondary, chatroomName, message, closeButton, mainRoomButton} = this.props;

        let mainRoomUrl = Registry.get('chatInterface').getPrimaryRoomURL();

        let className = 'popup popup-login-error ' + this.state.visibility;
// console.log(message);
// console.log(lang[message]);
        if (chatUrlSecondary && chatroomNameSecondary && chatroomName) {

            let completeChatroomName = chatroomName.indexOf("BobTV") === -1 ? "BobTV " + chatroomName : chatroomName;
            let completeChatroomNameSecondary = chatroomNameSecondary.indexOf("BobTV") === -1 ? "BobTV " + chatroomNameSecondary : chatroomNameSecondary;

            return (
                <div className={className} ref={(ref) => this._ref = ref}>
                    <p>{lang.too_many_users_popup(completeChatroomName)}</p>
                    {chatUrlSecondary && chatroomNameSecondary && <a className="popup-button enter_secondary" href={lang.path + chatUrlSecondary}>{lang.enter} {completeChatroomNameSecondary}</a>}
                    <a target="_blank" className="popup-button become_xxl" href={lang.path + '/bobtv-xxl'}>{lang.become_xxl}</a>
                </div>
            )
        } else if (message && lang[message]) {
            return (
                <div className={className} ref={(ref) => this._ref = ref}>
                    <p dangerouslySetInnerHTML={{__html: typeof lang[message] == 'function' ? lang[message].call({}, this.props) : lang[message]}}/>
                    {mainRoomButton && <a className="popup-button enter" href={mainRoomUrl}>{lang.enter_main_room}</a>}
                    {closeButton && <a className="popup-button close" href="/" onClick={() => !window.close()}>{lang.close}</a>}
                </div>
            )
        }

        return <div ref={(ref) => this._ref = ref} />;
    }
}

LoginErrorPopup.generateKey = function() { return 'login-error-popup' };
LoginErrorPopup.mount = function(props, onMount) { return Popup.mount(LoginErrorPopup, props, onMount) };
LoginErrorPopup.open = function(props) {
    let id = LoginErrorPopup.generateKey(props);

    if (!Popup.popups[id]) {
        LoginErrorPopup.mount(props, () => Popup.popups[id].open());
    } else {
        Popup.popups[id].open()
    }
};
LoginErrorPopup.close = function(props) {
    let id = LoginErrorPopup.generateKey(props);

    if (Popup.popups[id]) {
        Popup.popups[id].close();
    }
};

export default LoginErrorPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/LoginErrorPopup/index.js